module.exports = __webpack_public_path__ + "img/cityName.46ce237e.svg";